module.exports = __webpack_public_path__ + "img/fybrr_logo.df05cc00.svg";